import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  currentTeamId: '',
  teamDetails: {
    memberIds: [],
    teammateInfo: {},
    teamMemberNames: {},
  },
}

export const teamSlice = createSlice({
  name: 'team',
  initialState,

  reducers: {
    setCurrentTeamId: (state, action) => {
      state.currentTeamId = action.payload ?? ''
    },
    createNewCurrentTeamId: (state, action) => {
      state.currentTeamId = action.payload.currentTeamId
    },
    setTeamDetails: (state, action) => {
      // Used by Firebase wrapper to update local state from server (merge to preserve teammateInfo set by setTeammateInfo)
      const payload = action.payload ?? initialState.teamDetails
      state.teamDetails = { ...state.teamDetails, ...payload }
      // Normalize memberIds to array (Firebase returns object {0:'uid1',1:'uid2'}) and filter teammateInfo for departed members
      if (payload.memberIds != null) {
        const memberIdsArr = Array.isArray(payload.memberIds)
          ? payload.memberIds
          : Object.values(payload.memberIds || {})
        state.teamDetails.memberIds = memberIdsArr
        if (state.teamDetails.teammateInfo) {
          state.teamDetails.teammateInfo = Object.fromEntries(
            Object.entries(state.teamDetails.teammateInfo).filter(([uid]) => memberIdsArr.includes(uid))
          )
        }
      }
    },
    setTeammateInfo: (state, action) => {
      if (action.payload?.name && action.payload?.uid) {
        const { uid, name, color, character } = action.payload
        const memberIds = state.teamDetails?.memberIds
        const memberIdsArr = Array.isArray(memberIds)
          ? memberIds
          : Object.values(memberIds || {})
        if (!memberIdsArr.includes(uid)) return // Don't add/update info for members who have left
        if (!state.teamDetails.teammateInfo) {
          state.teamDetails.teammateInfo = {}
        }
        state.teamDetails.teammateInfo[uid] = {
          name,
          color: color ?? null,
          character: character ?? null,
        }
      }
    },
    resetTeam: (state) => {
      return { ...initialState }
    },
  },
})

export const {
  setCurrentTeamId,
  createNewCurrentTeamId,
  setTeamDetails,
  setTeammateInfo,
  resetTeam,
} = teamSlice.actions

export default teamSlice.reducer
